/**
 * @author Sunny Li（李丹）
 * @email sunnyli@mail.staritgp.com
 * @date 2018/10/19 14:53
 */
import React from 'react'
import { REMINDER_ASSETS_CODE } from 'types/enum'
type showPrivilegeModal = (status: boolean, modalType?: string, privilegeUseAsset?: MyServiceItem) => void
type PrivilegeListener = (type: REMINDER_ASSETS_CODE, times: number) => void

type PrivilegeData = Record<REMINDER_ASSETS_CODE, MyServiceItem> | undefined

interface WithPrivilegeUsePropTypes {
  privilegeUse?: PrivilegeData
  showPrivilegeModal: showPrivilegeModal,
  loadAssetsReminderData: () => void
  privilegeListener: PrivilegeListener,
}

const context = React.createContext({} as WithPrivilegeUsePropTypes)
const { Provider, Consumer } = context
/**
 * 高阶组件，传递 plan体系的数据
 * @param Component {function | React.Component}
 * @return {function(*): *}
 */
export default Component => function withPrivilegeUse (props) {
  return (
    <Consumer>
      {
        ({ privilegeUse, showPrivilegeModal, loadAssetsReminderData, privilegeListener }) => (
          <Component
            privilegeListener={privilegeListener}
            loadAssetsReminderData={loadAssetsReminderData}
            privilegeUse={privilegeUse}
            showPrivilegeModal={showPrivilegeModal}
            {...props}
          />
        )
      }
    </Consumer>
  )
}

export { Provider as PrivilegeUseProvider, context as PrivilegeUseContext, WithPrivilegeUsePropTypes }
